"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityPlatformActivity = exports.EntityPlatformActivityDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var client_1 = require("@apollo/client");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var react_infinite_scroll_hook_1 = __importDefault(require("react-infinite-scroll-hook"));
var platform_activity_entry_card_1 = require("./platform-activity-entry-card");
var wait_message_1 = require("../elements/wait-message");
var loading_layout_1 = require("../elements/loading-layout");
var lodash_1 = require("lodash");
var icon_title_1 = require("../elements/icon-title");
var sprintf_js_1 = require("sprintf-js");
exports.EntityPlatformActivityDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InfiniteContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: ", ";\n    ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n  "], ["\n    margin-left: ", ";\n    ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(5, -1), theme_1.theme.V_DOT_BG('lineSidebar'), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(9))
});
var WaitMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(25)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "])))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var WaitMessageContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme_1.theme.MAX('content-width'))
});
var NoActivityStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    margin: 0;\n    padding: ", ";\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    margin: 0;\n    padding: ", ";\n  "])), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('text-subtle'), theme_1.theme.UNIT(3))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: ", ";\n    font-weight: 500;\n  "], ["\n    padding: ", ";\n    font-weight: 500;\n  "])), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: (0, styled_components_1.default)(icon_title_1.IconTitle)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  InfiniteContainer: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), InfiniteContainerStyles),
  NoActivity: styled_components_1.default.p(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), NoActivityStyles),
  Items: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: (0, styled_components_1.default)(platform_activity_entry_card_1.PlatformActivityEntryCard)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  WaitMessageContainer: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageContainerStyles),
  WaitMessage: (0, styled_components_1.default)(wait_message_1.WaitMessage)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles)
};
var EntityPlatformActivity = function (props) {
  var className = props.className,
    entity = props.entity;
  var t = (0, use_lang_1.useLang)();
  var variables = {
    id: entity.id,
    input: {
      limit: 10
    }
  };
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var _a = (0, client_1.useQuery)(definition.platformActivity.query, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      variables: variables
    }),
    data = _a.data,
    error = _a.error,
    loading = _a.loading,
    fetchMore = _a.fetchMore;
  var resultsKey = "".concat(definition.singleTypeName);
  var resultsPath = "".concat(definition.singleTypeName, ".platformActivity");
  var items = (0, lodash_1.get)(data, "".concat(resultsPath, ".results"), []);
  var meta = (0, lodash_1.get)(data, "".concat(resultsPath, ".meta"), {
    count: 0,
    total: 0
  });
  var hasNextPage = meta.total > items.length;
  var fetchMoreParams = {
    variables: __assign(__assign({}, variables), {
      input: __assign(__assign({}, variables.input), {
        skip: items.length
      })
    }),
    updateQuery: function (prev, _a) {
      var _b;
      var fetchMoreResult = _a.fetchMoreResult;
      if (!fetchMoreResult) return prev;
      var resultPrev = (0, lodash_1.get)(prev, resultsKey, {
        results: []
      });
      var result = (0, lodash_1.get)(fetchMoreResult, resultsPath, {
        results: []
      });
      var prevResults = (0, lodash_1.get)(prev, "".concat(resultsPath, ".results"), []);
      var newResult = (_b = {}, _b[resultsKey] = __assign(__assign({}, resultPrev), {
        platformActivity: __assign(__assign({}, resultPrev.platformActivity), {
          results: __spreadArray(__spreadArray([], __read(prevResults), false), __read(result.results), false)
        })
      }), _b);
      return newResult;
    }
  };
  var onLoadMore = function () {
    fetchMore(fetchMoreParams);
  };
  // console.log(data);
  var Icons = (0, use_icons_1.useIcons)();
  var _b = __read((0, react_infinite_scroll_hook_1.default)({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      rootMargin: '0px 0px 100px 0px'
    }), 2),
    sentryRef = _b[0],
    rootRef = _b[1].rootRef;
  var hasItems = !!items.length;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.InfiniteContainer, {
    ref: rootRef
  }, loading && items.length === 0 ? react_1.default.createElement(My.LoadingLayout, null, t('Please wait...')) : hasItems ? react_1.default.createElement("div", null, !!items.length && react_1.default.createElement(My.Title, {
    size: "small",
    icon: Icons.Feed
  }, (0, sprintf_js_1.sprintf)(t('%s Feed'), definition.label)), react_1.default.createElement(My.Items, null, items.map(function (item) {
    return react_1.default.createElement(My.Item, {
      showIndicators: true,
      key: item.id,
      entry: item
    });
  })), (loading || hasNextPage) && react_1.default.createElement(My.WaitMessageContainer, {
    ref: sentryRef
  }, react_1.default.createElement(My.WaitMessage, {
    loading: loading
  }, t('Loading. Please wait...')))) : react_1.default.createElement(My.NoActivity, null, t('This item has no recent activity'))));
};
exports.EntityPlatformActivity = EntityPlatformActivity;
exports.EntityPlatformActivity.defaultProps = exports.EntityPlatformActivityDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;